import {
  decimal,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid,
  varchar,
} from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { users } from "./users"

// enums
export const reportTypeEnum = pgEnum("report_type_enum", [
  "ASSET_OWNERSHIP_AND_BENEFICIARIES",
  "CORPORATE",
  "HEALTH",
  "INSURANCE",
  "ESTATE_GOALS_AND_RELATIONSHIPS",
  "TAXES",
  "TRUST",
  "PROBATE",
  "ESTATE_SUMMARY",
  "WILL_REVIEW",
  "INSURANCE_REVIEW",
  "TRUST_REVIEW",
  "RETIREMENT_PLAN",
  "FINANCIAL_PLAN",
  "ESTATE_PLAN",
  "TAX_PLAN",
])

// Lookup Tables

// Purpose: Defines types of tax calculations.
export const taxCalcTypes = pgTable("tax_calc_type", {
  id: uuid("id").primaryKey().defaultRandom(),
  name: varchar("name", { length: 100 }).notNull().unique(),
})

// Core Tables

// Purpose: Stores metadata about generated estate planning reports.
export const reports = pgTable(
  "report",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    estateId: uuid("estate_id")
      .notNull()
      .references(() => estates.id, { onDelete: "cascade" }),
    reportType: reportTypeEnum("report_type_enum").notNull(),
    generatedByUserId: varchar("generated_by_user_id", { length: 255 })
      .notNull()
      .references(() => users.id, { onDelete: "cascade" }),
    generationDate: timestamp("generation_date").defaultNow().notNull(),
    content: text("content"),
    summaryNotes: text("summary_notes"),
    structuredData: text("structured_data"), // JSON-encoded infographic data for WILL_REVIEW reports
    createdAt: timestamp("created_at").defaultNow().notNull(),
    // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
    // a database trigger is required. This schema sets the timestamp on creation,
    // and application logic or a trigger should handle updates.
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
  },
  (t) => ({
    estateIdReportTypeUnique: uniqueIndex("report_estate_id_report_type_uq").on(
      t.estateId,
      t.reportType,
    ),
  }),
)

// Purpose: Records details of tax calculations performed for an estate.
export const taxCalcs = pgTable("tax_calc", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  taxCalcTypeId: uuid("tax_calc_type_id")
    .notNull()
    .references(() => taxCalcTypes.id),
  calculationDate: timestamp("calculation_date").defaultNow().notNull(),
  resultValue: decimal("result_value", { precision: 18, scale: 2 }).notNull(),
  details: text("details"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
